import script from "./WarningMobileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WarningMobileCard.vue?vue&type=script&setup=true&lang=js"

import "./WarningMobileCard.vue?vue&type=style&index=0&id=b97a61dc&lang=css"

const __exports__ = script;

export default __exports__